export class Label{
    id:number;
    language:string;
    value:string;
}